import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  DropdownButton,
  MenuItem,
  FormGroup,
  InputGroup,
  FormControl,
  Modal,
  ControlLabel,
  Glyphicon,
  Row,
  Checkbox,
  Col
} from "react-bootstrap";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import {
  savePaymentSetting,
  getPaymentSetting
} from "../../../redux/actions/payemntSettingAction";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import "../../../style/react-paginating.css";
import Dialog from "react-bootstrap-dialog";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import {aclUtil} from "../../util"

const history = createBrowserHistory();

class PaymentSetting extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'PAYMENT_SETTING',
      path: ["Home", "Payment Setting"],
      links: ["home",'payment-setting'],
      guestCheckout: "enable",
      includeApplicationRefundFee: "enable",
      includeDefaultTaxInApplicationFeeAmount:"enable",
      includeApplicationMerRemittanceFee: "enable",
      referall: "enable",
      stripeAccountType: "stripeAccount",
      referralAmount: "",
      environment: "sandbox",
      authorizeSandBoxLoginID: "",
      authorizeSandBoxTransactionKey: "",
      authorizeSandBoxSecretKey: "",
      authorizeLiveLoginID: "",
      authorizeLiveTransactionKey: "",
      authorizeLiveSecretKey: "",
      allowPaymentAuthCheckout: "0",
      allowPaymentAuthRefunds: "0",
      allowPaymentPaypalCheckout: "0",
      allowPaymentPaypalRefunds: "0",
      allowPaymentChaseCheckout: "0",
      allowPaymentChaseRefunds: "0",
      allowPaymentPaywayCheckout: "0",
      allowPaymentPaywayRefunds: "0",
      allowPaymentStripeCheckout: "0",
      allowPaymentStripeRefunds: "0",
      paypalSandBoxUsername: "",
      paypalSandBoxPassword: "",
      paypalSandBoxSignature: "",
      paypalLiveUsername: "",
      paypalLivePassword: "",
      paypalLiveSignature: "",
      stripeSandboxSecretKey: "",
      includeDefaultTaxInApplicationFeeAmountValue:0,
      stripeSandboxConnectedAcc: "",
      stripeliveSecretKey: "",
      stripeLiveConnectedAcc: "",
      alertMessage: "",
      show: false,
      disabled: false,
      submitValue: "Save",
      referralAmountError: "",
      Chase_live_bin: "",
      Chase_live_merchant_id: "",
      Chase_live_password: "",
      Chase_live_terminal_id: "",
      Chase_live_username: "",
      Chase_test_bin: "",
      Chase_test_merchant_id: "",
      Chase_test_password: "",
      Chase_test_terminal_id: "",
      Chase_test_username: "",
      Payway_live_idDivision: "",
      Payway_live_idSource: "",
      Payway_live_password: "",
      Payway_live_url: "",
      Payway_live_username: "",
      Payway_sanbox_idDivision: "",
      Payway_sanbox_idSource: "",
      Payway_sanbox_password: "",
      Payway_sanbox_url: "",
      Payway_sanbox_username: "",
      authorizeLiveTransactionKeyType: "password",
      authorizeSandTransactionKeyType: "password",
      paypalSandBoxPasswordType: "password",
      paypalSandBoxSignatureType: "password",
      paypalLivePasswordType: "password",
      paypalLiveSignatureType: "password",
      stripeSandboxSecretKeyType: "password",
      stripeSandboxConnectedAccType: "password",
      stripeLiveSecretKeyType: "password",
      stripeLiveConnectedAccType: "password",
      Chase_test_passwordType: "password",
      Chase_live_passwordType: "password",
      Payway_sanbox_passwordType: "password",
      Payway_live_passwordType: "password",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validate = this.validate.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
  }

  handleChange = e => {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }

    this.setState({ [e.target.name]: e.target.value });
  }; 

  validate = () => {
    let isError = false;
    const errors = {};

    if (this.state.referall == "enable") {
      if (this.state.referralAmount === "") {
        isError = true;
        this.setState({ referralAmountError: "red" });
      }
    }

    if (this.state.referall == "enable") {
      if (!this.state.referralAmount) {
        isError = true;
        this.setState({ referralAmountError: "red" });
      }
    }
    return isError;
  };

  handleSubmit = e => {
    e.preventDefault();
    const err = this.validate();
    if (!err) {
      this.setState({ submitValue: "Saving..", disabled: true });
      const formData = new FormData();
      formData.append("settings['guestCheckout']", (this.state.guestCheckout) ? this.state.guestCheckout : 'enable');
      formData.append("settings['includeApplicationRefundFee']", (this.state.includeApplicationRefundFee) ? this.state.includeApplicationRefundFee : 'enable');
      formData.append("settings['includeDefaultTaxInApplicationFeeAmount']", (this.state.includeDefaultTaxInApplicationFeeAmount) ? this.state.includeDefaultTaxInApplicationFeeAmount : 'enable');
      formData.append("settings['includeApplicationMerRemittanceFee']", (this.state.includeApplicationMerRemittanceFee) ? this.state.includeApplicationMerRemittanceFee : 'enable');
      formData.append("settings['referall']", this.state.referall);
      formData.append("settings['stripeAccountType']", this.state.stripeAccountType);
      formData.append("settings['referralAmount']", this.state.referralAmount);
      formData.append("settings['environment']", this.state.environment);
      formData.append(
        "settings['authorizeSandBoxLoginID']",
        (this.state.authorizeSandBoxLoginID) ? this.state.authorizeSandBoxLoginID : ""
      );
      formData.append(
        "settings['authorizeSandBoxTransactionKey']",
        (this.state.authorizeSandBoxTransactionKey) ? this.state.authorizeSandBoxTransactionKey : ""
      );
      formData.append(
        "settings['authorizeSandBoxSecretKey']",
        (this.state.authorizeSandBoxSecretKey) ? this.state.authorizeSandBoxSecretKey : ""
      );
      formData.append(
        "settings['authorizeLiveLoginID']",
        (this.state.authorizeLiveLoginID) ? this.state.authorizeLiveLoginID : ""
      );
      formData.append(
        "settings['authorizeLiveTransactionKey']",
        (this.state.authorizeLiveTransactionKey) ? this.state.authorizeLiveTransactionKey : ""
      );
      formData.append(
        "settings['authorizeLiveSecretKey']",
        (this.state.authorizeLiveSecretKey) ? this.state.authorizeLiveSecretKey : ""
      );
      formData.append(
        "settings['allowPaymentAuthCheckout']",
        (this.state.allowPaymentAuthCheckout) ? this.state.allowPaymentAuthCheckout : "0"
      );
      formData.append(
        "settings['allowPaymentAuthRefunds']",
        (this.state.allowPaymentAuthRefunds) ? this.state.allowPaymentAuthRefunds : "0"
      );
      formData.append(
        "settings['paypalSandBoxUsername']",
        (this.state.paypalSandBoxUsername) ? this.state.paypalSandBoxUsername : ""
      );
      formData.append(
        "settings['paypalSandBoxPassword']",
        (this.state.paypalSandBoxPassword) ? this.state.paypalSandBoxPassword : ""
      );
      formData.append(
        "settings['paypalSandBoxSignature']",
        (this.state.paypalSandBoxSignature) ? this.state.paypalSandBoxSignature : ""
      );
      formData.append(
        "settings['paypalLiveUsername']",
        (this.state.paypalLiveUsername) ? this.state.paypalLiveUsername : "" 
      );
      formData.append(
        "settings['paypalLivePassword']",
        (this.state.paypalLivePassword) ? this.state.paypalLivePassword : ""
      );
      formData.append(
        "settings['paypalLiveSignature']",
        (this.state.paypalLiveSignature) ? this.state.paypalLiveSignature : ""
      );
      formData.append(
        "settings['allowPaymentPaypalCheckout']",
        (this.state.allowPaymentPaypalCheckout) ? this.state.allowPaymentPaypalCheckout : "0"
      );
      formData.append(
        "settings['allowPaymentPaypalRefunds']",
        (this.state.allowPaymentPaypalRefunds) ? this.state.allowPaymentPaypalRefunds : "0"
      );
      formData.append(
        "settings['stripeSandboxSecretKey']",
        (this.state.stripeSandboxSecretKey) ? this.state.stripeSandboxSecretKey : ""
      );
      formData.append(
        "settings['includeDefaultTaxInApplicationFeeAmountValue']",
        (this.state.includeDefaultTaxInApplicationFeeAmountValue) ? this.state.includeDefaultTaxInApplicationFeeAmountValue : 0
      );
      formData.append(
        "settings['stripeSandboxConnectedAcc']",
        (this.state.stripeSandboxConnectedAcc) ? this.state.stripeSandboxConnectedAcc : ""
      );
      formData.append(
        "settings['stripeLiveSecretKey']",
        (this.state.stripeLiveSecretKey) ? this.state.stripeLiveSecretKey : ""
      );
      formData.append(
        "settings['stripeLiveConnectedAcc']",
        (this.state.stripeLiveConnectedAcc) ? this.state.stripeLiveConnectedAcc : ""
      );
      formData.append(
        "settings['allowPaymentStripeCheckout']",
        (this.state.allowPaymentStripeCheckout) ? this.state.allowPaymentStripeCheckout : "0"
      );
      formData.append(
        "settings['allowPaymentStripeRefunds']",
        (this.state.allowPaymentStripeRefunds) ? this.state.allowPaymentStripeRefunds : "0"
      );
      formData.append("settings['Chase_live_bin']", (this.state.Chase_live_bin) ? this.state.Chase_live_bin : "");
      formData.append("settings['Chase_live_merchant_id']", (this.state.Chase_live_merchant_id) ? this.state.Chase_live_merchant_id : "");
      formData.append("settings['Chase_live_password']", (this.state.Chase_live_password) ? this.state.Chase_live_password : "");
      formData.append("settings['Chase_live_terminal_id']", (this.state.Chase_live_terminal_id) ? this.state.Chase_live_terminal_id : "");
      formData.append("settings['Chase_live_username']", (this.state.Chase_live_username) ? this.state.Chase_live_username : "");
      formData.append("settings['Chase_test_bin']", (this.state.Chase_test_bin) ? this.state.Chase_test_bin : "");
      formData.append("settings['Chase_test_merchant_id']", (this.state.Chase_test_merchant_id) ? this.state.Chase_test_merchant_id : "");
      formData.append("settings['Chase_test_password']", (this.state.Chase_test_password) ? this.state.Chase_test_password : "");
      formData.append("settings['Chase_test_terminal_id']", (this.state.Chase_test_terminal_id) ? this.state.Chase_test_terminal_id : "");
      formData.append("settings['Chase_test_username']", (this.state.Chase_test_username) ? this.state.Chase_test_username : "");
      formData.append(
        "settings['allowPaymentChaseCheckout']",
        (this.state.allowPaymentChaseCheckout) ? this.state.allowPaymentChaseCheckout : "0"
      );
      formData.append(
        "settings['allowPaymentChaseRefunds']",
        (this.state.allowPaymentChaseRefunds) ? this.state.allowPaymentChaseRefunds : "0"
      );
      formData.append("settings['Payway_live_idDivision']", (this.state.Payway_live_idDivision) ? this.state.Payway_live_idDivision : "");
      formData.append("settings['Payway_live_idSource']", (this.state.Payway_live_idSource) ? this.state.Payway_live_idSource : "");
      formData.append("settings['Payway_live_password']", (this.state.Payway_live_password) ? this.state.Payway_live_password : "");
      formData.append("settings['Payway_live_url']", (this.state.Payway_live_url) ? this.state.Payway_live_url : "");
      formData.append("settings['Payway_live_username']", (this.state.Payway_live_username) ? this.state.Payway_live_username : "");
      formData.append("settings['Payway_sanbox_idDivision']", (this.state.Payway_sanbox_idDivision) ? this.state.Payway_sanbox_idDivision : "");
      formData.append("settings['Payway_sanbox_idSource']", (this.state.Payway_sanbox_idSource) ? this.state.Payway_sanbox_idSource : "");
      formData.append("settings['Payway_sanbox_password']", (this.state.Payway_sanbox_password) ? this.state.Payway_sanbox_password : "");
      formData.append("settings['Payway_sanbox_url']", (this.state.Payway_sanbox_url) ? this.state.Payway_sanbox_url : "");
      formData.append("settings['Payway_sanbox_username']", (this.state.Payway_sanbox_username) ? this.state.Payway_sanbox_username : ""); 
      formData.append(
        "settings['allowPaymentPaywayCheckout']",
        (this.state.allowPaymentPaywayCheckout) ? this.state.allowPaymentPaywayCheckout : "0"
      );
      formData.append(
        "settings['allowPaymentPaywayRefunds']",
        (this.state.allowPaymentPaywayRefunds) ? this.state.allowPaymentPaywayRefunds : "0"
      );
      this.props.savePaymentSetting(formData);
    }
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleCheck(e) {
    if (e.target.checked == true) {
      this.setState({ [e.target.name]: 1 });
    } else {
      this.setState({ [e.target.name]: 0 });
    }
  }

  componentDidMount() {}

  componentWillMount() {
    this.props.clearAlert();
    this.handleDismiss();
    this.props.getPaymentSetting();
  }


  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }

    //test
    if (this.props.settingStatus !== nextProps.settingStatus) {
      if (nextProps.settingStatus) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.settingStatus.message);
        this.setState({ submitValue: "Save", disabled: false });
        window.scrollTo(0, 0);
      }

    }

    if (this.props.paymentSetting !== nextProps.paymentSetting) {
      if (nextProps.paymentSetting) {
        let data = nextProps.paymentSetting.data;
        this.setState({
          guestCheckout: data.guestCheckout,
          includeApplicationRefundFee: data.includeApplicationRefundFee,
          includeDefaultTaxInApplicationFeeAmount:data.includeDefaultTaxInApplicationFeeAmount,
          includeApplicationMerRemittanceFee: data.includeApplicationMerRemittanceFee,
          referall: data.referall,
          referralAmount: data.referralAmount,
          environment: (data.environment) ? data.environment : 'sandbox',
          authorizeSandBoxLoginID: data.authorizeSandBoxLoginID,
          authorizeSandBoxTransactionKey: data.authorizeSandBoxTransactionKey,
          authorizeSandBoxSecretKey: data.authorizeSandBoxSecretKey,
          authorizeLiveLoginID: data.authorizeLiveLoginID,
          authorizeLiveTransactionKey: data.authorizeLiveTransactionKey,
          authorizeLiveSecretKey: data.authorizeLiveSecretKey,
          allowPaymentAuthCheckout: data.allowPaymentAuthCheckout,
          allowPaymentAuthRefunds: data.allowPaymentAuthRefunds,
          paypalSandBoxUsername: data.paypalSandBoxUsername,
          paypalSandBoxPassword: data.paypalSandBoxPassword,
          paypalSandBoxSignature: data.paypalSandBoxSignature,
          paypalLiveUsername: data.paypalLiveUsername,
          paypalLivePassword: data.paypalLivePassword,
          paypalLiveSignature: data.paypalLiveSignature,
          allowPaymentPaypalCheckout: data.allowPaymentPaypalCheckout,
          allowPaymentPaypalRefunds: data.allowPaymentPaypalRefunds,
          stripeSandboxSecretKey: data.stripeSandboxSecretKey,
          includeDefaultTaxInApplicationFeeAmountValue:data.includeDefaultTaxInApplicationFeeAmountValue,
          stripeSandboxConnectedAcc: data.stripeSandboxConnectedAcc,
          stripeLiveSecretKey: data.stripeLiveSecretKey,
          stripeLiveConnectedAcc: data.stripeLiveConnectedAcc,
          allowPaymentStripeCheckout: data.allowPaymentStripeCheckout,
          allowPaymentStripeRefunds: data.allowPaymentStripeRefunds,
          stripeAccountType: data.stripeAccountType ? data.stripeAccountType : 'stripeAccount',
          Chase_live_bin: data.Chase_live_bin,
          Chase_live_merchant_id: data.Chase_live_merchant_id,
          Chase_live_password: data.Chase_live_password,
          Chase_live_terminal_id: data.Chase_live_terminal_id,
          Chase_live_username: data.Chase_live_username,
          Chase_test_bin: data.Chase_test_bin,
          Chase_test_merchant_id: data.Chase_test_merchant_id,
          Chase_test_password: data.Chase_test_password,
          Chase_test_terminal_id: data.Chase_test_terminal_id,
          Chase_test_username: data.Chase_test_username,
          allowPaymentChaseCheckout: data.allowPaymentChaseCheckout,
          allowPaymentChaseRefunds: data.allowPaymentChaseRefunds,
          Payway_live_idDivision: data.Payway_live_idDivision,
          Payway_live_idSource: data.Payway_live_idSource,
          Payway_live_password: data.Payway_live_password,
          Payway_live_url: data.Payway_live_url,
          Payway_live_username: data.Payway_live_username,
          Payway_sanbox_idDivision: data.Payway_sanbox_idDivision,
          Payway_sanbox_idSource: data.Payway_sanbox_idSource,
          Payway_sanbox_password: data.Payway_sanbox_password,
          Payway_sanbox_url: data.Payway_sanbox_url,
          Payway_sanbox_username: data.Payway_sanbox_username,
          allowPaymentPaywayCheckout: data.allowPaymentPaywayCheckout,
          allowPaymentPaywayRefunds: data.allowPaymentPaywayRefunds,
        });
      }
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.setState({ submitValue: "Save", disabled: false });
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        window.scrollTo(0, 0);
      }
    }
    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
      window.scrollTo(0, 0);
    }
  }

  render() {
    let allowPaymentAuthCheckoutChecked = this.state.allowPaymentAuthCheckout == "1" ? "true" : "";
    let allowPaymentAuthRefundsChecked = this.state.allowPaymentAuthRefunds == "1" ? "true" : "";
    let allowPaymentPaypalCheckoutChecked = this.state.allowPaymentPaypalCheckout == "1" ? "true" : "";
    let allowPaymentPaypalRefundsChecked = this.state.allowPaymentPaypalRefunds == "1" ? "true" : "";
    let allowPaymentChaseCheckoutChecked = this.state.allowPaymentChaseCheckout == "1" ? "true" : "";
    let allowPaymentChaseRefundsChecked = this.state.allowPaymentChaseRefunds == "1" ? "true" : "";
    let allowPaymentPaywayCheckoutChecked = this.state.allowPaymentPaywayCheckout == "1" ? "true" : "";
    let allowPaymentPaywayRefundsChecked = this.state.allowPaymentPaywayRefunds == "1" ? "true" : "";
    let allowPaymentStripeCheckoutChecked = this.state.allowPaymentStripeCheckout == "1" ? "true" : "";
    let allowPaymentStripeRefundsChecked = this.state.allowPaymentStripeRefunds == "1" ? "true" : "";
    return (
      <div>
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />

        <div className="col-lg-12 user-list">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
            </div>
          </div>
          <form onSubmit={this.handleSubmit}>
            {this.state.show &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}
            <Row>
              {/*Referall System Start*/}
              <Col md={4} xs={12}>
                <div className="panel">
                  <header className="panel-heading">
                    Guest Checkout Switch
                  </header>
                  <div className="panel-body">
                    <Row>
                      <Col md={12} xs={12}>
                        <ControlLabel>Guest Checkout</ControlLabel>
                        <FormControl
                          componentClass="select"
                          style={{ borderColor: this.state.guestCheckoutError }}
                          name="guestCheckout"
                          onChange={this.handleChange}
                          value={this.state.guestCheckout}
                        >
                          <option value="enable">Enable</option>
                          <option value="disable">Disable</option>
                        </FormControl>
                      </Col>
                    </Row>
                  </div>
                  <div className="clearfix" />
                </div>
              </Col>
              {/*Referall System End*/}

              {/*Referall System Start*/}
              <Col md={4} xs={12}>
                <div className="panel">
                  <header className="panel-heading">
                    Referral System Switch
                  </header>
                  <div className="panel-body">
                    <Row>
                      <Col md={12} xs={12}>
                        <ControlLabel>Referral System</ControlLabel>
                        <FormControl
                          componentClass="select"
                          style={{ borderColor: this.state.referallError }}
                          name="referall"
                          onChange={this.handleChange}
                          value={this.state.referall}
                        >
                          <option value="enable">Enable</option>
                          <option value="disable">Disable</option>
                        </FormControl>
                        {this.state.referall == "enable" ? (
                          <div>
                            <ControlLabel>Referral Amount</ControlLabel>
                            <FormControl
                              type="number"
                              placeholder="Referral Amount"
                              name="referralAmount"
                              onChange={this.handleChange}
                              value={this.state.referralAmount}
                              style={{
                                borderColor: this.state.referralAmountError
                              }}
                            />
                          </div>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                  </div>
                  <div className="clearfix" />
                </div>
              </Col>
              {/*Referall System End*/}

              {/*Payment API Environment Setting Start*/}
              <Col md={4} xs={12}>
                <div className="panel">
                  <header className="panel-heading">
                    Payment API Environment
                  </header>
                  <div className="panel-body">
                    <Row>
                      <Col md={12} xs={12}>
                        <ControlLabel>Environment</ControlLabel>
                        <FormControl
                          componentClass="select"
                          style={{ borderColor: this.state.environmentError }}
                          name="environment"
                          onChange={this.handleChange}
                          value={this.state.environment}
                        >
                          <option value="sandbox">Sandbox</option>
                          <option value="live">Live</option>
                        </FormControl>
                      </Col>
                    </Row>
                  </div>
                  <div className="clearfix" />
                </div>
              </Col>
              {/*Payment API Environment Setting End*/}
            </Row>
            {/*Authorize.net Setting Start*/}
            <div className="panel">
              <header className="panel-heading">Authorize.Net</header>
              <div className="panel-body">
                <Row>
                  <Col md={6} xs={12}>
                    <Row>
                      <Col md={12} xs={12}>
                        <ControlLabel>
                          <h4>Sandbox Environment</h4>
                        </ControlLabel>
                        <hr />
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>API Login ID</ControlLabel>
                        <FormGroup controlId="authorizeSandBoxLoginID">
                          <FormControl
                            type="text"
                            value={this.state.authorizeSandBoxLoginID}
                            placeholder="API Login ID"
                            onChange={this.handleChange}
                            name="authorizeSandBoxLoginID"
                            style={{
                              borderColor: this.state
                                .authorizeSandBoxLoginIDError
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Transaction Key</ControlLabel>
                        <FormGroup controlId="authorizeSandTransactionKey">
                          <InputGroup>
                            <FormControl
                              type={this.state.authorizeSandTransactionKeyType}
                              value={this.state.authorizeSandBoxTransactionKey}
                              placeholder="Transaction Key"
                              onChange={this.handleChange}
                              name="authorizeSandBoxTransactionKey"
                              style={{
                                borderColor: this.state
                                  .authorizeSandBoxTransactionKeyError
                              }}
                            />
                            {this.state.authorizeSandTransactionKeyType=='password' &&
                              <InputGroup.Addon onClick={() => this.setState({authorizeSandTransactionKeyType:'text'})}> 
                                  <Glyphicon glyph="eye-open"/>  
                              </InputGroup.Addon>
                            }
                            {this.state.authorizeSandTransactionKeyType=='text' &&
                              <InputGroup.Addon onClick={() => this.setState({authorizeSandTransactionKeyType:'password'})}>   
                                  <Glyphicon glyph="eye-close" /> 
                              </InputGroup.Addon>
                            }
                          </InputGroup>
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Secret Key</ControlLabel>
                        <FormGroup controlId="authorizeSSecretKey">
                          <FormControl
                            type="text"
                            value={this.state.authorizeSandBoxSecretKey}
                            placeholder="Secret Key"
                            onChange={this.handleChange}
                            name="authorizeSandBoxSecretKey"
                            style={{
                              borderColor: this.state
                                .authorizeSandBoxSecretKeyError
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Allow Payment Type For Authorize</ControlLabel>
                        <FormGroup controlId="authorizeSSecretKey">
                          <Checkbox
                            className="allowPayment"
                            name="allowPaymentAuthCheckout"
                            checked={allowPaymentAuthCheckoutChecked}
                            value={this.state.allowPaymentAuthCheckout}
                            onChange={this.handleCheck}
                            inline
                          >
                            Allow Payment Type on Checkout Page
                          </Checkbox>
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                          <Checkbox
                            className="checkBox"
                            name="allowPaymentAuthRefunds"
                            checked={allowPaymentAuthRefundsChecked}
                            value={this.state.allowPaymentAuthRefunds}
                            onChange={this.handleCheck}
                            inline
                          >
                            Allow Payment Type on Refunds
                          </Checkbox>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={6} xs={12}>
                    <Row>
                      <Col md={12} xs={12}>
                        <ControlLabel>
                          <h4>Live Environment</h4>
                        </ControlLabel>
                        <hr />
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>API Login ID</ControlLabel>
                        <FormGroup controlId="authorizeLLoginID">
                          <FormControl
                            type="text"
                            value={this.state.authorizeLiveLoginID}
                            placeholder="API Login ID"
                            onChange={this.handleChange}
                            name="authorizeLiveLoginID"
                            style={{
                              borderColor: this.state.authorizeLiveLoginIDError
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Transaction Key</ControlLabel>
                        <FormGroup controlId="authorizeLTransactionKey">
                          <InputGroup>
                            <FormControl
                              type={this.state.authorizeLiveTransactionKeyType}
                              value={this.state.authorizeLiveTransactionKey}
                              placeholder="Transaction Key"
                              onChange={this.handleChange}
                              name="authorizeLiveTransactionKey"
                              style={{
                                borderColor: this.state
                                  .authorizeLiveTransactionKeyError
                              }}
                            />
                            {this.state.authorizeLiveTransactionKeyType=='password' &&
                              <InputGroup.Addon onClick={() => this.setState({authorizeLiveTransactionKeyType:'text'})}>
                                <Glyphicon glyph="eye-open" />
                              </InputGroup.Addon>
                            }
                            {this.state.authorizeLiveTransactionKeyType=='text' &&
                              <InputGroup.Addon onClick={() => this.setState({authorizeLiveTransactionKeyType:'password'})}>
                                <Glyphicon glyph="eye-close" />
                              </InputGroup.Addon>
                            }
                          </InputGroup>
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Secret Key</ControlLabel>
                        <FormGroup controlId="authorizeLSecretKey">
                          <FormControl
                            type="text"
                            value={this.state.authorizeLiveSecretKey}
                            placeholder="Secret Key"
                            onChange={this.handleChange}
                            name="authorizeLiveSecretKey"
                            style={{
                              borderColor: this.state
                                .authorizeLiveSecretKeyError
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
              <div className="clearfix" />
            </div>
            {/*Authorize.net Setting End*/}

            {/*Authorize.net Setting Start*/}
            <div className="panel">
              <header className="panel-heading">Paypal REST API Credentials</header>
              <div className="panel-body">
                <Row>
                  <Col md={6} xs={12}>
                    <Row>
                      <Col md={12} xs={12}>
                        <ControlLabel>
                          <h4>Sandbox Environment</h4>
                        </ControlLabel>
                        <hr />
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Paypal Account</ControlLabel>
                        <FormGroup controlId="paypalSandUsername">
                          <FormControl
                            type="text"
                            value={this.state.paypalSandBoxUsername}
                            placeholder="User Name"
                            onChange={this.handleChange}
                            name="paypalSandBoxUsername"
                            style={{
                              borderColor: this.state.paypalSandBoxUsernameError
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Secret</ControlLabel>
                        <FormGroup controlId="paypalSandPassword">
                          <InputGroup>
                            <FormControl
                              type={this.state.paypalSandBoxPasswordType}
                              value={this.state.paypalSandBoxPassword}
                              placeholder="Password"
                              onChange={this.handleChange}
                              name="paypalSandBoxPassword"
                              style={{
                                borderColor: this.state.paypalSandBoxPasswordError
                              }}
                            />
                            {this.state.paypalSandBoxPasswordType=='password' &&
                              <InputGroup.Addon onClick={() => this.setState({paypalSandBoxPasswordType:'text'})}>
                                <Glyphicon glyph="eye-open" />
                              </InputGroup.Addon>
                            }
                            {this.state.paypalSandBoxPasswordType=='text' &&
                              <InputGroup.Addon onClick={() => this.setState({paypalSandBoxPasswordType:'password'})}>
                                <Glyphicon glyph="eye-close" />
                              </InputGroup.Addon>
                            }
                          </InputGroup>
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Client ID</ControlLabel>
                        <FormGroup controlId="paypalSandBoxSignature">
                          <InputGroup>
                            <FormControl
                              type={this.state.paypalSandBoxSignatureType}
                              value={this.state.paypalSandBoxSignature}
                              placeholder="Signature"
                              onChange={this.handleChange}
                              name="paypalSandBoxSignature"
                              style={{
                                borderColor: this.state
                                  .paypalSandBoxSignatureError
                              }}
                            />
                            {this.state.paypalSandBoxSignatureType=='password' &&
                              <InputGroup.Addon onClick={() => this.setState({paypalSandBoxSignatureType:'text'})}>
                                <Glyphicon glyph="eye-open" />
                              </InputGroup.Addon>
                            }
                            {this.state.paypalSandBoxSignatureType=='text' &&
                              <InputGroup.Addon onClick={() => this.setState({paypalSandBoxSignatureType:'password'})}>
                                <Glyphicon glyph="eye-close" />
                              </InputGroup.Addon>
                            }
                          </InputGroup>
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Allow Payment Type For Paypal</ControlLabel>
                        <FormGroup controlId="allowPaymentPaypal">
                          <Checkbox
                            className="allowPayment"
                            name="allowPaymentPaypalCheckout"
                            checked={allowPaymentPaypalCheckoutChecked}
                            value={this.state.allowPaymentPaypalCheckout}
                            onChange={this.handleCheck}
                            inline
                          >
                            Allow Payment Type on Checkout Page
                          </Checkbox>
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                          <Checkbox
                            className="checkBox"
                            name="allowPaymentPaypalRefunds"
                            checked={allowPaymentPaypalRefundsChecked}
                            value={this.state.allowPaymentPaypalRefunds}
                            onChange={this.handleCheck}
                            inline
                          >
                            Allow Payment Type on Refunds
                          </Checkbox>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={6} xs={12}>
                    <Row>
                      <Col md={12} xs={12}>
                        <ControlLabel>
                          <h4>Live Environment</h4>
                        </ControlLabel>
                        <hr />
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Paypal Account</ControlLabel>
                        <FormGroup controlId="paypalLiveUsername">
                          <FormControl
                            type="text"
                            value={this.state.paypalLiveUsername}
                            placeholder="User Name"
                            onChange={this.handleChange}
                            name="paypalLiveUsername"
                            style={{
                              borderColor: this.state.paypalLiveUsernameError
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Secret</ControlLabel>
                        <FormGroup controlId="paypalLivePassword">
                          <InputGroup>
                            <FormControl
                              type={this.state.paypalLivePasswordType}
                              value={this.state.paypalLivePassword}
                              placeholder="Password"
                              onChange={this.handleChange}
                              name="paypalLivePassword"
                              style={{
                                borderColor: this.state.paypalLivePasswordError
                              }}
                            />
                            {this.state.paypalLivePasswordType=='password' &&
                              <InputGroup.Addon onClick={() => this.setState({paypalLivePasswordType:'text'})}>
                                <Glyphicon glyph="eye-open" />
                              </InputGroup.Addon>
                            }
                            {this.state.paypalLivePasswordType=='text' &&
                              <InputGroup.Addon onClick={() => this.setState({paypalLivePasswordType:'password'})}>
                                <Glyphicon glyph="eye-close" />
                              </InputGroup.Addon>
                            }
                          </InputGroup>
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Client ID</ControlLabel>
                        <FormGroup controlId="paypalLiveSignature">
                          <InputGroup>
                            <FormControl
                              type={this.state.paypalLiveSignatureType}
                              value={this.state.paypalLiveSignature}
                              placeholder="Signature"
                              onChange={this.handleChange}
                              name="paypalLiveSignature"
                              style={{
                                borderColor: this.state.paypalLiveSignatureError
                              }}
                            />
                            {this.state.paypalLiveSignatureType=='password' &&
                              <InputGroup.Addon onClick={() => this.setState({paypalLiveSignatureType:'text'})}>
                                <Glyphicon glyph="eye-open" />
                              </InputGroup.Addon>
                            }
                            {this.state.paypalLiveSignatureType=='text' &&
                              <InputGroup.Addon onClick={() => this.setState({paypalLiveSignatureType:'password'})}>
                                <Glyphicon glyph="eye-close" />
                              </InputGroup.Addon>
                            }
                          </InputGroup>
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
              <div className="clearfix" />
            </div>

            {/*Chase payment gateway*/}
            <div className="panel">
              <header className="panel-heading">Chase PaymentTech</header>
              <div className="panel-body">
                <Row>
                  <Col md={6} xs={12}>
                    <Row>
                      <Col md={12} xs={12}>
                        <ControlLabel>
                          <h4>Sandbox Environment</h4>
                        </ControlLabel>
                        <hr />
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Chase Test Bin</ControlLabel>
                        <FormGroup controlId="Chase_sanbox_bin">
                          <FormControl
                            type="text"
                            value={this.state.Chase_test_bin}
                            placeholder="Chase Test Bin"
                            onChange={this.handleChange}
                            name="Chase_test_bin"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Chase Test Merchant Id</ControlLabel>
                        <FormGroup controlId="Chase_test_merchant_id">
                          <FormControl
                            type="text"
                            value={this.state.Chase_test_merchant_id}
                            placeholder="Chase Test Merchant Id"
                            onChange={this.handleChange}
                            name="Chase_test_merchant_id"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Chase Test Password</ControlLabel>
                        <FormGroup controlId="Chase_test_password">
                          <InputGroup>
                            <FormControl
                              type={this.state.Chase_test_passwordType}
                              value={this.state.Chase_test_password}
                              placeholder="Chase Test Password"
                              onChange={this.handleChange}
                              name="Chase_test_password"
                            />
                            {this.state.Chase_test_passwordType=='password' &&
                              <InputGroup.Addon onClick={() => this.setState({Chase_test_passwordType:'text'})}>
                                <Glyphicon glyph="eye-open" />
                              </InputGroup.Addon>
                            }
                            {this.state.Chase_test_passwordType=='text' &&
                              <InputGroup.Addon onClick={() => this.setState({Chase_test_passwordType:'password'})}>
                                <Glyphicon glyph="eye-close" />
                              </InputGroup.Addon>
                            }
                          </InputGroup>
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Chase Test Username</ControlLabel>
                        <FormGroup controlId="Chase_test_username">
                          <FormControl
                            type="text"
                            value={this.state.Chase_test_username}
                            placeholder="Chase Test Username"
                            onChange={this.handleChange}
                            name="Chase_test_username"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Chase Test Terminal Id</ControlLabel>
                        <FormGroup controlId="Chase_test_terminal_id">
                          <FormControl
                            type="text"
                            value={this.state.Chase_test_terminal_id}
                            placeholder="Chase Test Terminal Id"
                            onChange={this.handleChange}
                            name="Chase_test_terminal_id"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Allow Payment Type For Chase</ControlLabel>
                        <FormGroup controlId="allowPaymentChase">
                          <Checkbox
                            className="allowPayment"
                            name="allowPaymentChaseCheckout"
                            checked={allowPaymentChaseCheckoutChecked}
                            value={this.state.allowPaymentChaseCheckout}
                            onChange={this.handleCheck}
                            inline
                          >
                            Allow Payment Type on Checkout Page
                          </Checkbox>
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                          <Checkbox
                            className="checkBox"
                            name="allowPaymentChaseRefunds"
                            checked={allowPaymentChaseRefundsChecked}
                            value={this.state.allowPaymentChaseRefunds}
                            onChange={this.handleCheck}
                            inline
                          >
                            Allow Payment Type on Refunds
                          </Checkbox>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={6} xs={12}>
                    <Row>
                      <Col md={12} xs={12}>
                        <ControlLabel>
                          <h4>Live Environment</h4>
                        </ControlLabel>
                        <hr />
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Chase Live Bin</ControlLabel>
                        <FormGroup controlId="Chase_live_bin">
                          <FormControl
                            type="text"
                            value={this.state.Chase_live_bin}
                            placeholder="Chase Live Bin"
                            onChange={this.handleChange}
                            name="Chase_live_bin"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Chase Live Merchant Id</ControlLabel>
                        <FormGroup controlId="Chase_live_merchant_id">
                          <FormControl
                            type="text"
                            value={this.state.Chase_live_merchant_id}
                            placeholder="Chase Live Merchant Id"
                            onChange={this.handleChange}
                            name="Chase_live_merchant_id"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Chase Live Password</ControlLabel>
                        <FormGroup controlId="Chase_live_password">
                          <InputGroup>
                            <FormControl
                              type={this.state.Chase_live_passwordType}
                              value={this.state.Chase_live_password}
                              placeholder="Chase Live Password"
                              onChange={this.handleChange}
                              name="Chase_live_password"
                            />
                            {this.state.Chase_live_passwordType=='password' &&
                              <InputGroup.Addon onClick={() => this.setState({Chase_live_passwordType:'text'})}>
                                <Glyphicon glyph="eye-open" />
                              </InputGroup.Addon>
                            }
                            {this.state.Chase_live_passwordType=='text' &&
                              <InputGroup.Addon onClick={() => this.setState({Chase_live_passwordType:'password'})}>
                                <Glyphicon glyph="eye-close" />
                              </InputGroup.Addon>
                            }
                          </InputGroup>
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Chase Live Username</ControlLabel>
                        <FormGroup controlId="Chase_live_username">
                          <FormControl
                            type="text"
                            value={this.state.Chase_live_username}
                            placeholder="Chase Live Username"
                            onChange={this.handleChange}
                            name="Chase_live_username"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Chase Live Terminal Id</ControlLabel>
                        <FormGroup controlId="Chase_live_terminal_id">
                          <FormControl
                            type="text"
                            value={this.state.Chase_live_terminal_id}
                            placeholder="Chase Live Terminal Id"
                            onChange={this.handleChange}
                            name="Chase_live_terminal_id"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
              <div className="clearfix" />
            </div>

            {/*Start Payway payment gateway*/}
            <div className="panel">
              <header className="panel-heading">PayWay PaymentTech</header>
              <div className="panel-body">
                <Row>
                  <Col md={6} xs={12}>
                    <Row>
                      <Col md={12} xs={12}>
                        <ControlLabel>
                          <h4>Sandbox Environment</h4>
                        </ControlLabel>
                        <hr />
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>PayWay Test Username</ControlLabel>
                        <FormGroup controlId="Payway_sanbox_username">
                          <FormControl
                            type="text"
                            value={this.state.Payway_sanbox_username}
                            placeholder="PayWay Test Username"
                            onChange={this.handleChange}
                            name="Payway_sanbox_username"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>PayWay Test Password</ControlLabel>
                        <FormGroup controlId="Payway_sanbox_password">
                          <InputGroup>
                            <FormControl
                              type={this.state.Payway_sanbox_passwordType}
                              value={this.state.Payway_sanbox_password}
                              placeholder="PayWay Test Password"
                              onChange={this.handleChange}
                              name="Payway_sanbox_password"
                            />
                            {this.state.Payway_sanbox_passwordType=='password' &&
                              <InputGroup.Addon onClick={() => this.setState({Payway_sanbox_passwordType:'text'})}>
                                <Glyphicon glyph="eye-open" />
                              </InputGroup.Addon>
                            }
                            {this.state.Payway_sanbox_passwordType=='text' &&
                              <InputGroup.Addon onClick={() => this.setState({Payway_sanbox_passwordType:'password'})}>
                                <Glyphicon glyph="eye-close" />
                              </InputGroup.Addon>
                            }
                          </InputGroup>
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>PayWay Test Division Id</ControlLabel>
                        <FormGroup controlId="Payway_sanbox_idDivision">
                          <FormControl
                            type="text"
                            value={this.state.Payway_sanbox_idDivision}
                            placeholder="PayWay Test Division Id"
                            onChange={this.handleChange}
                            name="Payway_sanbox_idDivision"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>PayWay Test Source Id</ControlLabel>
                        <FormGroup controlId="Payway_sanbox_idSource">
                          <FormControl
                            type="text"
                            value={this.state.Payway_sanbox_idSource}
                            placeholder="PayWay Test Source Id"
                            onChange={this.handleChange}
                            name="Payway_sanbox_idSource"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>PayWay Test Url</ControlLabel>
                        <FormGroup controlId="Payway_sanbox_url">
                          <FormControl
                            type="text"
                            value={this.state.Payway_sanbox_url}
                            placeholder="PayWay Test Url"
                            onChange={this.handleChange}
                            name="Payway_sanbox_url"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Allow Payment Type For Payway</ControlLabel>
                        <FormGroup controlId="allowPaymentPayway">
                          <Checkbox
                            className="allowPayment"
                            name="allowPaymentPaywayCheckout"
                            checked={allowPaymentPaywayCheckoutChecked}
                            value={this.state.allowPaymentPaywayCheckout}
                            onChange={this.handleCheck}
                            inline
                          >
                            Allow Payment Type on Checkout Page
                          </Checkbox>
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                          <Checkbox
                            className="checkBox"
                            name="allowPaymentPaywayRefunds"
                            checked={allowPaymentPaywayRefundsChecked}
                            value={this.state.allowPaymentPaywayRefunds}
                            onChange={this.handleCheck}
                            inline
                          >
                            Allow Payment Type on Refunds
                          </Checkbox>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={6} xs={12}>
                    <Row>
                      <Col md={12} xs={12}>
                        <ControlLabel>
                          <h4>Live Environment</h4>
                        </ControlLabel>
                        <hr />
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>PayWay Live Username</ControlLabel>
                        <FormGroup controlId="Payway_live_username">
                          <FormControl
                            type="text"
                            value={this.state.Payway_live_username}
                            placeholder="PayWay Live Username"
                            onChange={this.handleChange}
                            name="Payway_live_username"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>PayWay Live Password</ControlLabel>
                        <FormGroup controlId="Payway_live_password">
                          <InputGroup>
                            <FormControl
                              type={this.state.Payway_live_passwordType}
                              value={this.state.Payway_live_password}
                              placeholder="PayWay Live Password"
                              onChange={this.handleChange}
                              name="Payway_live_password"
                            />
                            {this.state.Payway_live_passwordType=='password' &&
                              <InputGroup.Addon onClick={() => this.setState({Payway_live_passwordType:'text'})}>
                                <Glyphicon glyph="eye-open" />
                              </InputGroup.Addon>
                            }
                            {this.state.Payway_live_passwordType=='text' &&
                              <InputGroup.Addon onClick={() => this.setState({Payway_live_passwordType:'password'})}>
                                <Glyphicon glyph="eye-close" />
                              </InputGroup.Addon>
                            }
                          </InputGroup>
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>PayWay Live Division Id</ControlLabel>
                        <FormGroup controlId="Payway_live_idDivision">
                          <FormControl
                            type="text"
                            value={this.state.Payway_live_idDivision}
                            placeholder="PayWay Live Division Id"
                            onChange={this.handleChange}
                            name="Payway_live_idDivision"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>PayWay Live Source Id</ControlLabel>
                        <FormGroup controlId="Payway_live_idSource">
                          <FormControl
                            type="text"
                            value={this.state.Payway_live_idSource}
                            placeholder="PayWay Live Source Id"
                            onChange={this.handleChange}
                            name="Payway_live_idSource"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>PayWay Live Url</ControlLabel>
                        <FormGroup controlId="Payway_live_url">
                          <FormControl
                            type="text"
                            value={this.state.Payway_live_url}
                            placeholder="PayWay Live Source Id"
                            onChange={this.handleChange}
                            name="Payway_live_url"
                          />
                        </FormGroup>
                      </Col> 
                    </Row>
                  </Col>

                </Row>

              </div>
              <div className="clearfix" />
            </div>
            {/*End Payway payment gateway*/}

            {/*Stripe Payment Gateway Start*/}
            <div className="panel">
              <header className="panel-heading">Stripe REST API Credentials</header>
              <div className="panel-body">
                <Row>
                  <Col md={6} xs={12}>
                    <ControlLabel>Stripe Account Type</ControlLabel>
                      <FormControl
                        componentClass="select"
                        style={{ borderColor: this.state.stripeAccountTypeError }}
                        name="stripeAccountType"
                        onChange={this.handleChange}
                        value={this.state.stripeAccountType}
                      >
                        <option value="stripeAccount">Stripe Account</option>
                        <option value="connectedAccount">Stripe Connected Account</option>
                      </FormControl>
                  </Col>
                </Row>
                <Row>
                  <Col md={6} xs={12}>
                    <Row>
                      <Col md={12} xs={12}>
                        <ControlLabel>
                          <h4>Sandbox Environment</h4>
                        </ControlLabel>
                        <hr />
                      </Col>
                      {this.state.stripeAccountType == "stripeAccount" && (
                      <Col md={12} xs={12}>
                        <ControlLabel>Stripe Secret Key</ControlLabel>
                        <FormGroup controlId="stripeSandSecretKey">
                          <InputGroup>
                            <FormControl
                              type={this.state.stripeSandboxSecretKeyType}
                              value={this.state.stripeSandboxSecretKey}
                              placeholder="Stripe Secret Key"
                              onChange={this.handleChange}
                              name="stripeSandboxSecretKey"
                              style={{
                                borderColor: this.state.stripeSandboxSecretKeyError
                              }}
                            />
                            {this.state.stripeSandboxSecretKeyType=='password' &&
                              <InputGroup.Addon onClick={() => this.setState({stripeSandboxSecretKeyType:'text'})}>
                                <Glyphicon glyph="eye-open" />
                              </InputGroup.Addon>
                            }
                            {this.state.stripeSandboxSecretKeyType=='text' &&
                              <InputGroup.Addon onClick={() => this.setState({stripeSandboxSecretKeyType:'password'})}>
                                <Glyphicon glyph="eye-close" />
                              </InputGroup.Addon>
                            }
                          </InputGroup>
                        </FormGroup>
                      </Col>
                      )}
                      {this.state.stripeAccountType == "connectedAccount" && (
                      <Col md={12} xs={12}>
                        <ControlLabel>Connected Stripe Account ID</ControlLabel>
                        <FormGroup controlId="stripeSandConnectedAcc">
                          <InputGroup>
                            <FormControl
                              type={this.state.stripeSandboxConnectedAccType}
                              value={this.state.stripeSandboxConnectedAcc}
                              placeholder="Connected Stripe Accound ID"
                              onChange={this.handleChange}
                              name="stripeSandboxConnectedAcc"
                              style={{
                                borderColor: this.state
                                  .stripeSandboxConnectedAccError
                              }}
                            />
                            {this.state.stripeSandboxConnectedAccType=='password' &&
                              <InputGroup.Addon onClick={() => this.setState({stripeSandboxConnectedAccType:'text'})}>
                                <Glyphicon glyph="eye-open" />
                              </InputGroup.Addon>
                            }
                            {this.state.stripeSandboxConnectedAccType=='text' &&
                              <InputGroup.Addon onClick={() => this.setState({stripeSandboxConnectedAccType:'password'})}>
                                <Glyphicon glyph="eye-close" />
                              </InputGroup.Addon>
                            }
                          </InputGroup>
                        </FormGroup>
                      </Col>
                      )}
                      <Col md={12} xs={12}>
                        <ControlLabel>Allow Payment Type For Stripe</ControlLabel>
                        <FormGroup controlId="allowPaymentStripe">
                          <Checkbox
                            className="allowPayment"
                            name="allowPaymentStripeCheckout"
                            checked={allowPaymentStripeCheckoutChecked}
                            value={this.state.allowPaymentStripeCheckout}
                            onChange={this.handleCheck}
                            inline
                          >
                            Allow Payment Type on Checkout Page
                          </Checkbox>
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                          <Checkbox
                            className="checkBox"
                            name="allowPaymentStripeRefunds"
                            checked={allowPaymentStripeRefundsChecked}
                            value={this.state.allowPaymentStripeRefunds}
                            onChange={this.handleCheck}
                            inline
                          >
                            Allow Payment Type on Refunds
                          </Checkbox>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Include Merchant Remittance in Application Fee Amount</ControlLabel>
                        <FormControl
                          componentClass="select"
                          style={{ borderColor: this.state.includeApplicationMerRemittanceFeeError }}
                          name="includeApplicationMerRemittanceFee"
                          onChange={this.handleChange}
                          value={this.state.includeApplicationMerRemittanceFee}
                        >
                          <option value="enable">Enable</option>
                          <option value="disable">Disable</option>
                        </FormControl>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Include Application Fee Amount Against Refunds</ControlLabel>
                        <FormControl
                          componentClass="select"
                          style={{ borderColor: this.state.includeApplicationRefundFeeError }}
                          name="includeApplicationRefundFee"
                          onChange={this.handleChange}
                          value={this.state.includeApplicationRefundFee}
                        >
                          <option value="enable">Enable</option>
                          <option value="disable">Disable</option>
                        </FormControl>
                      </Col>

                      {/*includeDefaultTaxInApplicationFeeAmount Start*/}
                      {this.state.stripeAccountType == "connectedAccount" && (
                      <Col md={12} xs={12}>
                        <ControlLabel>Include Default Tax Amount in Application Fee Amount</ControlLabel>
                        <FormControl
                          componentClass="select"
                          style={{ borderColor: this.state.includeDefaultTaxInApplicationFeeAmountError }}
                          name="includeDefaultTaxInApplicationFeeAmount"
                          onChange={this.handleChange}
                          value={this.state.includeDefaultTaxInApplicationFeeAmount}
                        >
                          <option value="enable">Enable</option>
                          <option value="disable">Disable</option>
                        </FormControl>
                      </Col>)}
                      {/*{this.state.stripeAccountType == "connectedAccount" && (
                      <Col md={12} xs={12} style={{marginLeft: "101%",marginTop: "-61px"}}>
                        <ControlLabel>Default Tax Amount</ControlLabel>
                        <FormGroup controlId="includeDefaultTaxInApplicationFeeAmountValue">
                          <FormControl
                            type="number"
                            value={this.state.includeDefaultTaxInApplicationFeeAmountValue}
                            placeholder="Enter Default Tax Amount"
                            onChange={this.handleChange}
                            name="includeDefaultTaxInApplicationFeeAmountValue"
                          />
                        </FormGroup>
                      </Col>)}
                     includeDefaultTaxInApplicationFeeAmount End*/}
                    </Row>
                  </Col>
                  <Col md={6} xs={12}>
                    <Row>
                      <Col md={12} xs={12}>
                        <ControlLabel>
                          <h4>Live Environment</h4>
                        </ControlLabel>
                        <hr />
                      </Col>
                      {this.state.stripeAccountType == "stripeAccount" && (
                      <Col md={12} xs={12}>
                        <ControlLabel>Stripe Secret Key</ControlLabel>
                        <FormGroup controlId="stripeLiveSecretKey">
                          <InputGroup>
                            <FormControl
                              type={this.state.stripeLiveSecretKeyType}
                              value={this.state.stripeLiveSecretKey}
                              placeholder="Stripe Secret Key"
                              onChange={this.handleChange}
                              name="stripeLiveSecretKey"
                              style={{
                                borderColor: this.state.stripeLiveSecretKeyError
                              }}
                            />
                            {this.state.stripeLiveSecretKeyType=='password' &&
                              <InputGroup.Addon onClick={() => this.setState({stripeLiveSecretKeyType:'text'})}>
                                <Glyphicon glyph="eye-open" />
                              </InputGroup.Addon>
                            }
                            {this.state.stripeLiveSecretKeyType=='text' &&
                              <InputGroup.Addon onClick={() => this.setState({stripeLiveSecretKeyType:'password'})}>
                                <Glyphicon glyph="eye-close" />
                              </InputGroup.Addon>
                            }
                          </InputGroup>
                        </FormGroup>
                      </Col>
                      )}
                      {this.state.stripeAccountType == "connectedAccount" && (
                      <Col md={12} xs={12}>
                        <ControlLabel>Connected Stripe Account ID</ControlLabel>
                        <FormGroup controlId="stripeLiveConnectedAcc">
                          <InputGroup>
                            <FormControl
                              type={this.state.stripeLiveConnectedAccType}
                              value={this.state.stripeLiveConnectedAcc}
                              placeholder="Connected Stripe Accound ID"
                              onChange={this.handleChange}
                              name="stripeLiveConnectedAcc"
                              style={{
                                borderColor: this.state.stripeLiveConnectedAccError
                              }}
                            />
                            {this.state.stripeLiveConnectedAccType=='password' &&
                              <InputGroup.Addon onClick={() => this.setState({stripeLiveConnectedAccType:'text'})}>
                                <Glyphicon glyph="eye-open" />
                              </InputGroup.Addon>
                            }
                            {this.state.stripeLiveConnectedAccType=='text' &&
                              <InputGroup.Addon onClick={() => this.setState({stripeLiveConnectedAccType:'password'})}>
                                <Glyphicon glyph="eye-close" />
                              </InputGroup.Addon>
                            }
                          </InputGroup>
                        </FormGroup>
                      </Col>
                      )}
                    </Row>
                  </Col>
               
                </Row>
              </div>
              <div className="clearfix" />
            </div>
            {/*Authorize.net Setting End*/}
            {/*Authorize.net Setting End*/}
            <Row className="BtnRow">
              <Col md={12} xs={12}>
                <Button
                  bsStyle="info"
                  type="submit"
                  id="saveButton"
                  disabled={this.state.disabled}
                >
                  {this.state.submitValue}
                </Button>
                <Button
                  bsStyle="default"
                  onClick={() => this.context.router.history.push(`/dashboard`)}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          </form>
        </div>
      </div>
    );
  }
}

PaymentSetting.propTypes = {
  savePaymentSetting: PropTypes.func.isRequired,
  getPaymentSetting: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  settingStatus: state.paymentSettingReducer.settingStatus,
  paymentSetting: state.paymentSettingReducer.paymentSetting,
  error: state.paymentSettingReducer.error,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message
});

export default withRouter(connect(mapStateToProps, {
  savePaymentSetting,
  getPaymentSetting,
  renderAlert,
  clearAlert
})(PaymentSetting));



// WEBPACK FOOTER //
// ./src/app/views/admin/paymentSetting/PaymentSetting.js